import {observer} from 'mobx-react-lite'
import React, {useMemo} from 'react'
import {Lang} from 'yougile-lang'
import {LinkButton} from '@components/common/base/buttons'
import {canAdd} from '@components/dashboard/dashboard-utils'
import {CompanyProject} from '../company-projects-store'
import {AddProjectButton} from './add-project-button'
import {ProjectListItem} from './project-list-item'

interface ProjectListBaseProps {
  projects: CompanyProject[]
  maxCount: number
  onMoreClick: () => void
  canAddProjects?: boolean
}

export const ProjectListBase = observer(
  ({projects, canAddProjects, maxCount, onMoreClick}: ProjectListBaseProps) => {
    const displayedProjects = useMemo(
      () => projects.slice(0, maxCount),
      [projects, maxCount]
    )
    const projectsLeft = projects.length - displayedProjects.length

    return (
      <div>
        <div className="flex flex-row flex-wrap gap-16">
          {displayedProjects.map(({hub, users}) => (
            <ProjectListItem key={hub.id} project={hub} users={users} />
          ))}
          {canAddProjects && canAdd() && <AddProjectButton />}
        </div>
        {projectsLeft > 0 && (
          <div className="flex flex-row mt-8">
            <LinkButton
              icon="IconDotsCircleHorizontal"
              onClick={onMoreClick}
              size="small"
            >
              {Lang.msg.proj.showMore(projectsLeft)}
            </LinkButton>
          </div>
        )}
      </div>
    )
  }
)
